import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { DownCaratIcon } from 'foundations-assets/icons/components/DownCaratIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { useTheme } from 'foundations-theming/utils';
import MobileCatalogSelector from './MobileCatalogSelector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileCatalogMenu = ({
  categories,
  hsSoftwareCategories,
  inlineLink,
  buttonText = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "learningCenter.heading.headingLinks.browseCatalog"
  }),
  selectedFilterType,
  selectedGroup,
  onClickOption
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const theme = useTheme();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    blockSize: theme.space['1000'],
    display: "inline-flex",
    inlineSize: "auto",
    justifyContent: "center",
    marginBlock: "0",
    children: [/*#__PURE__*/_jsx(Link, {
      "data-test-id": "category-selector-panel-button",
      display: !inlineLink ? 'inline-block' : undefined,
      onClick: () => {
        setMenuOpen(true);
      },
      padding: !inlineLink ? '250' : undefined,
      use: inlineLink ? 'blue' : 'on-dark',
      children: buttonText
    }), inlineLink && /*#__PURE__*/_jsx(IconHolder, {
      color: "icon-core-subtle",
      icon: DownCaratIcon,
      size: "100"
    }), /*#__PURE__*/_jsx(MobileCatalogSelector, {
      categories: categories,
      "data-test-id": "mobile-category-selector-panel",
      hsSoftwareCategories: hsSoftwareCategories,
      menuOpen: menuOpen,
      onClickOption: onClickOption,
      selectedFilterType: selectedFilterType,
      selectedGroup: selectedGroup,
      setMenuOpen: setMenuOpen
    })]
  });
};
export default MobileCatalogMenu;